import { ImageOptimization } from '@components/image-optimization'
import styles from './styles.module.scss'

interface AuthorResume {
  name: string
  avatarUrl?: string
}

export const AuthorResume = ({ name, avatarUrl }: AuthorResume) => {
  return (
    <div className={styles.biographyHeader}>
      {avatarUrl && (
        <div className={styles.imgContainer}>
          <ImageOptimization alt={name} src={avatarUrl} />
        </div>
      )}
      <h2 className={styles.text}>{name}</h2>
    </div>
  )
}
